import { useEffect, useState } from "react";

/**
 * Tiny breakpoint hook backed by matchMedia. Avoids shipping a CSS-in-JS
 * library just to switch column counts on a handful of pages.
 *
 *  const { isMobile, isTablet } = useBreakpoint();
 */
export function useBreakpoint() {
  const [state, setState] = useState(() => measure());

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mqMobile = window.matchMedia("(max-width: 640px)");
    const mqTablet = window.matchMedia("(max-width: 960px)");
    const onChange = () => setState(measure());
    mqMobile.addEventListener("change", onChange);
    mqTablet.addEventListener("change", onChange);
    return () => {
      mqMobile.removeEventListener("change", onChange);
      mqTablet.removeEventListener("change", onChange);
    };
  }, []);

  return state;
}

function measure() {
  if (typeof window === "undefined") {
    return { isMobile: false, isTablet: false };
  }
  return {
    isMobile: window.matchMedia("(max-width: 640px)").matches,
    isTablet: window.matchMedia("(max-width: 960px)").matches,
  };
}
